import { useMemo } from "react";

import { Box, Typography } from "@mui/material"

import { ingredientsPerServingSelector } from "../../app/commonSelector";
import { RatingSummary, RecipeState } from "../../app/recipePage/recipePage.types";
import { useAppSelector } from "../../app/store/hooks";
import { Allergen, Clock, Flame, PrepIcon } from "../../iconRef/recipePageIcons";
import { getAllAllergens, getTotalMacros } from "../../utils/experience2/ingredientsUtil";
import { TextPrimaryBold, TextSmallBold } from "../typography";
import RatingsSummary from "./RatingsSummary";
import { formattingRecipeTime } from "./recipeUtils";

const RecipeDescription = ({ recipe, ratingsSummary }: { recipe: RecipeState, ratingsSummary: RatingSummary }) => {
    const cookTime = recipe?.metadata?.cookTime;
    const prepTime = recipe?.metadata?.prepTime;
    const cookTimeFormatted = formattingRecipeTime(cookTime);
    const prepTimeFormatted = formattingRecipeTime(prepTime);
    const ingredientsPerServing = useAppSelector(ingredientsPerServingSelector)

    const allergens = useMemo(() => getAllAllergens(ingredientsPerServing), [ingredientsPerServing])
    const totalMacros = useMemo(() => getTotalMacros(ingredientsPerServing), [ingredientsPerServing])

    return (
        <Box sx={{ width: '92%', padding: '20px 4%', display: 'flex', flexDirection: 'column', gap: "20px" }}>

            <Box sx={{ gap: "10px" }}>
                <Box sx={{ display: 'flex' }}>
                    {
                        cookTime <= 0 ? null : <Box sx={{ backgroundColor: '#D4C6FF', justifyContent: "space-between", display: 'flex', alignItems: 'center', py: 1, px: 2, gap: "5px", borderRadius: recipe?.metadata?.prepTime === 0 ? "8px" : "8px 0 0 8px" }}>
                            <Clock />
                            <Typography variant="captionparalell">{cookTimeFormatted}</Typography>
                        </Box>
                    }

                    {recipe?.metadata?.prepTime !== 0 &&
                        <Box sx={{ backgroundColor: '#ffffff', display: 'flex', alignItems: 'center', gap: 1, py: 1, px: 2, borderRadius: '0 8px 8px 0' }}>
                            <PrepIcon />
                            <Typography variant="captionparalell">{prepTimeFormatted} prep</Typography>
                        </Box>}
                </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: "10px", flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}><Flame /><Typography variant="body5">Nutrition per serving</Typography></Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: '#fff', borderRadius: '10px' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '25%', gap: 1, py: 1, textAlign: 'center' }}>
                        <TextSmallBold text='Kcal' />
                        <TextPrimaryBold text={totalMacros?.calorie ?? 0} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '25%', gap: 1, py: 1, textAlign: 'center' }}>
                        <TextSmallBold text='Protein' />
                        <TextPrimaryBold text={`${totalMacros?.protein ?? 0}g`} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '25%', gap: 1, py: 1, textAlign: 'center' }}>
                        <TextSmallBold text='Fats' />
                        <TextPrimaryBold text={`${totalMacros?.fat ?? 0}g`} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', width: '25%', gap: 1, py: 1, textAlign: 'center' }}>
                        <TextSmallBold text='Carbs' />
                        <TextPrimaryBold text={`${totalMacros?.carbs ?? 0}g`} />
                    </Box>
                </Box>
            </Box>
            {allergens.length !== 0 && <Box sx={{ display: 'flex', flexDirection: 'column', borderRadius: '10px' }}>
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}></Box>
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: "5px" }}>
                    <Allergen />
                    <Typography variant="body5">Allergens: </Typography>
                    {allergens?.map((i: any, index: any) =>
                        <Typography key={i} variant="body5">{index === 0 ? i : ', ' + i}</Typography>
                    )}
                </Box>
            </Box>}

            <RatingsSummary ratingsSummary={ratingsSummary} recipeId={recipe?.id}/>
        </Box>
    )
}

export default RecipeDescription;
